import { actionCreator } from '../helpers/functions';
import * as ActionTypes from './index';

export const clearQuotesFilters = actionCreator(ActionTypes.CLEAR_QUOTES_FILTERS);

export function getQuotesSuggestions(payload) {
    return {
        type: ActionTypes.GET_QUOTES_SUGGESTIONS,
        payload: payload
    }
}

export function getQuotesSuggestionsSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTES_SUGGESTIONS_SUCCESS,
        payload: payload
    }
}

export function getQuotesSuggestionsFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTES_SUGGESTIONS_FAILED,
        payload: payload
    }
}

export function changeQuotesState(payload) {
    return {
        type: ActionTypes.CHANGE_QUOTES_STATE,
        payload: payload
    }
}

export function quotesListPageShift(payload) {
    return {
        type: ActionTypes.QUOTES_LIST_PAGE_SHIFT,
        payload: payload
    }
}

export function changeQuotesListPage(payload) {
    return {
        type: ActionTypes.CHANGE_QUOTES_LIST_PAGE,
        payload: payload
    }
}

export function getQuotes(payload) {
    return {
        type: ActionTypes.GET_QUOTES,
        payload: payload
    }
}

export function getQuotesSuccess(payload) {
    return {
        type: ActionTypes.GET_QUOTES_SUCCESS,
        payload: payload
    }
}

export function getQuotesFailed(payload) {
    return {
        type: ActionTypes.GET_QUOTES_FAILED,
        payload: payload
    }
}